@import url("https://cdn.jsdelivr.net/npm/bootstrap@5.1.3/dist/css/bootstrap.min.css"); 

/* @import url("../../../node_modules/bootstrap/dist/css/bootstrap.min.css");  */

:host {
  display: block;
}

a , a:visited {
  color: #b71d1d;
  font-size: 16px;
  text-decoration: none;
}

a:hover {
  color: #b71d1d;
  font-size: 16px;
 
}

.img-rounded-border {
  border:10px solid red;
  border-radius:10px;
}

#raw-html-style {
  padding:10px;
}

.card {
  border: 1px solid #63666a;
  padding: 10px;
}


::-webkit-scrollbar {
  width: 2px;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #D3D3D3; 
}

.modal-backdrop {
  display:none;
}
hr {
  height: 2px !important;
  
}

.quote {
  background: #f9f9f9;
  border-left: 10px solid #ccc;
  margin: 1.5em 10px;
  padding: 0.5em 10px;
  quotes: "\201C""\201D""\2018""\2019";
}

.quote:before {
  color: #ccc;
  content: open-quote;
  font-size: 4em;
  line-height: 0.1em;
  margin-right: 0.25em;
  vertical-align: -0.4em;
}
.quote:after {
  color: #ccc;
  content: close-quote;
  font-size: 4em;
  line-height: 0.1em;
  margin-right: 0.25em;
  vertical-align: -0.4em;
}
.card-title {
  display: block;
  margin-bottom: 5px;
}
.card-text {
  display: block;
  line-height: 1 !important;
}
.modal-title {
  margin-bottom: 5px;
}
.filterstyle {
  background-color: #F4F6FA;
  padding: 20px;
  border-radius: 10px;
}